module.exports = __webpack_public_path__ + "static/media/lock-yellow.e7a24258.svg";